import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const DocSidebar = ({ sections, activeSection, onSectionClick }) => {
  const { t } = useTranslation();
  const [expandedSections, setExpandedSections] = useState(
    sections.map((s) => s.id) // All expanded by default
  );
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const toggleSection = (sectionId) => {
    setExpandedSections((prev) =>
      prev.includes(sectionId)
        ? prev.filter((id) => id !== sectionId)
        : [...prev, sectionId]
    );
  };

  const handleNavClick = (sectionId) => {
    onSectionClick(sectionId);
    setIsMobileOpen(false); // Close mobile menu after selection
  };

  const isActive = (sectionId) => {
    return activeSection === sectionId || activeSection?.startsWith(sectionId);
  };

  const isSubsectionActive = (subsectionId) => {
    return activeSection === subsectionId;
  };

  return (
    <>
      {/* Mobile toggle button */}
      <button
        className="doc-sidebar-toggle"
        onClick={() => setIsMobileOpen(!isMobileOpen)}
        aria-label="Toggle documentation menu"
      >
        <i className={`bi ${isMobileOpen ? "bi-x-lg" : "bi-list"}`}></i>
        <span>{t("docs.tableOfContents")}</span>
      </button>

      {/* Sidebar */}
      <aside className={`doc-sidebar ${isMobileOpen ? "mobile-open" : ""}`}>
        <div className="doc-sidebar-header">
          <h3>{t("docs.tableOfContents")}</h3>
        </div>
        <nav className="doc-sidebar-nav">
          {sections.map((section) => (
            <div key={section.id} className="doc-nav-section">
              <button
                className={`doc-nav-section-title ${
                  isActive(section.id) ? "active" : ""
                }`}
                onClick={() => toggleSection(section.id)}
              >
                <span onClick={(e) => { e.stopPropagation(); handleNavClick(section.id); }}>
                  {section.title}
                </span>
                <i
                  className={`bi ${
                    expandedSections.includes(section.id)
                      ? "bi-chevron-down"
                      : "bi-chevron-right"
                  }`}
                ></i>
              </button>
              {expandedSections.includes(section.id) && section.subsections && (
                <ul className="doc-nav-subsections">
                  {section.subsections.map((subsection) => (
                    <li key={subsection.id}>
                      <button
                        className={`doc-nav-subsection ${
                          isSubsectionActive(subsection.id) ? "active" : ""
                        }`}
                        onClick={() => handleNavClick(subsection.id)}
                      >
                        {subsection.title}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </nav>
      </aside>

      {/* Mobile overlay */}
      {isMobileOpen && (
        <div
          className="doc-sidebar-overlay"
          onClick={() => setIsMobileOpen(false)}
        ></div>
      )}
    </>
  );
};

export default DocSidebar;
